'use strict';

/* eslint no-undef: "off" */
/**
 * static helper app
 */
define('staticHelperApp',['headerWrapper', 'staticHelperMain', 'sideMenu', 'searchPanel'], function (headerWrapper, staticHelperMain, sideMenu, searchPanel) {
  return {
    template: '\n      <div class="page-container static-page static-helper">\n        <side-menu></side-menu>\n        <div class="helper-body" :style="{height: height}">\n          <header-wrapper></header-wrapper>\n          <static-helper-main></static-helper-main>\n        </div>\n        <search-panel></search-panel>\n      </div>\n    ',
    data: function data() {
      return {
        height: '100%'
      };
    },

    components: {
      headerWrapper: headerWrapper,
      staticHelperMain: staticHelperMain,
      sideMenu: sideMenu,
      searchPanel: searchPanel
    },
    mounted: function mounted() {
      this.resetHeight();
    },

    methods: {
      resetHeight: function resetHeight() {
        var _this = this;

        var timer = void 0;
        this.height = window.innerHeight + 'px';
        window.addEventListener('resize', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            _this.height = window.innerHeight + 'px';
          }, 200);
        });
      }
    }
  };
});
